export default "__VITE_ASSET__Lmus3Qd8__"